var endpoint = 'https://pro.ip-api.com/json/?key=WCCXhmNoer9G3ng&fields=status,city,country,countryCode';

// Country to domain mapping
const countryDomainMap = {
  'United Kingdom': 'uk.transformertable.com',
  'Singapore': 'sg.transformertable.com',
  'Germany': 'ger.transformertable.com',
  'France': 'fr.transformertable.com', 
  'Australia': 'aus.transformertable.com'
};

// GCC countries
const gccCountries = [
  'United Arab Emirates',
  'Saudi Arabia',
  'Kuwait',
  'Qatar',
  'Bahrain',
  'Oman'
];

// European countries (excluding Germany and France)
const europeanCountries = [
  'Italy', 'Spain', 'Netherlands', 'Belgium', 'Switzerland', 'Austria',
  'Sweden', 'Norway', 'Denmark', 'Finland', 'Ireland', 'Portugal',
  'Greece', 'Poland', 'Czech Republic', 'Hungary', 'Romania', 'Bulgaria'
];

function setCookie(name, value, days) {
  var date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  var expires = "; expires=" + date.toGMTString();
  document.cookie = name + "=" + value + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

var xhr = new XMLHttpRequest();
xhr.onreadystatechange = function() {
  if (this.readyState == 4 && this.status == 200) {
    var response = JSON.parse(this.responseText);
    if(response.status !== 'success') {
      console.log('query failed: ' + response.message);
      return;
    }
    
    var user_country = response.country;
    
    // Skip redirection if already redirected
    if (getCookie('redirected') === 'true') {
      return;
    }

    // Handle Canada specifically
    if (user_country === 'Canada') {
      window.location.href = 'https://ca.transformertable.com';
      setCookie('redirected', 'true', 7);
      return;
    }

    // Handle specific country domains
    if (countryDomainMap[user_country]) {
      window.location.href = 'https://' + countryDomainMap[user_country];
      setCookie('redirected', 'true', 7);
      return;
    }

    // Handle GCC countries
    if (gccCountries.includes(user_country)) {
      window.location.href = 'https://gcc.transformertable.com';
      setCookie('redirected', 'true', 7);
      return;
    }

    // Handle European countries
    if (europeanCountries.includes(user_country)) {
      window.location.href = 'https://eu.transformertable.com';
      setCookie('redirected', 'true', 7);
      return;
    }

    // Handle United States (no redirect)
    if (user_country === 'United States') {
      return;
    }

    // Default redirect for rest of the world
    window.location.href = 'https://row.transformertable.com';
    setCookie('redirected', 'true', 7);
  }
};

xhr.open('GET', endpoint, true);
xhr.send();
